import { render, staticRenderFns } from "./PuntosDeEntregaLista.vue?vue&type=template&id=2a0f1ac3&"
import script from "./PuntosDeEntregaLista.vue?vue&type=script&lang=js&"
export * from "./PuntosDeEntregaLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports